import { avoidItems } from "@/mocks/gua";

const levelStyle: Record<string, { chip: string; bar: string }> = {
  红: { chip: "bg-primary-500 text-background-50", bar: "w-[92%] bg-primary-500" },
  橙: { chip: "bg-accent-500 text-background-50", bar: "w-[68%] bg-accent-500" },
  黄: { chip: "bg-accent-200 text-foreground-800", bar: "w-[42%] bg-accent-300" },
};

export default function AvoidListSection() {
  return (
    <section id="avoidlist" className="mx-auto max-w-6xl scroll-mt-28 px-4 py-16 md:px-6 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="text-xs font-medium tracking-[0.3em] text-primary-600">03 / 工具栏目</p>
          <h2 className="mt-3 font-display text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            避雷名单 · 持续收录
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            把口碑与信用踩出脚印的人物与品牌，吃瓜黑网持续收录进这份名单。等级越高风险越靠前，吃瓜下单前先对一眼。
          </p>
        </div>
        {/* 等级图例 */}
        <div className="flex items-center gap-4 text-xs text-foreground-600">
          {["红", "橙", "黄"].map((lv) => (
            <span key={lv} className="flex items-center gap-1.5">
              <i className={`${levelStyle[lv].chip} flex h-4 w-4 items-center justify-center rounded-sm text-[10px] not-italic`}>
                {lv}
              </i>
              高风险{lvlToWord(lv)}
            </span>
          ))}
        </div>
      </div>

      <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="flex flex-wrap items-center gap-3 border-b border-background-200 bg-background-100/60 px-5 py-3 text-xs text-foreground-500">
          <i className="ri-tools-line text-foreground-400" />
          <span>收录口径：官方通报 · 监管公示 · 多源交叉核实</span>
          <span className="ml-auto hidden sm:block">共 87 个对象持续跟踪</span>
        </div>

        <ul className="divide-y divide-background-200">
          {avoidItems.map((it) => (
            <li key={it.id} className="grid grid-cols-1 gap-4 px-5 py-5 transition-colors hover:bg-background-100/60 md:grid-cols-12 md:items-center">
              {/* 主体 */}
              <div className="flex items-center gap-4 md:col-span-5">
                <span className={`${levelStyle[it.level].chip} flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-display text-lg font-bold`}>
                  {it.level}
                </span>
                <div>
                  <h4 className="font-display text-base font-bold text-foreground-950">{it.name}</h4>
                  <p className="text-xs text-foreground-500">{it.field} · {it.updated}</p>
                </div>
              </div>
              {/* 风险原因 */}
              <p className="text-sm leading-relaxed text-foreground-700 md:col-span-4">{it.reason}</p>
              {/* 标签 + 等级条 */}
              <div className="md:col-span-3">
                <div className="flex flex-wrap gap-1.5">
                  {it.tags.map((t) => (
                    <span key={t} className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                      {t}
                    </span>
                  ))}
                </div>
                <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <span className={`block h-full rounded-full ${levelStyle[it.level].bar}`} />
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-6 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-accent-200 bg-accent-50 px-5 py-4">
        <p className="flex items-center gap-2 text-sm text-accent-900">
          <i className="ri-error-warning-fill text-accent-600" />
          名单仅供风险参考，不构成法律判断；争议双方均可来信补充材料。
        </p>
        <button
          type="button"
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-md border border-accent-300 px-3 py-1.5 text-xs font-medium text-accent-800 transition-colors hover:bg-accent-100"
        >
          <i className="ri-megaphone-line" />
          申请复核
        </button>
      </div>
    </section>
  );
}

function lvlToWord(lv: string) {
  return lv === "红" ? " · 强烈避雷" : lv === "橙" ? " · 谨慎对待" : " · 留意观察";
}